// Third-party imports
import React from 'react';
import {
  Edit,
  useNotify,
  useRefresh,
} from 'react-admin';

// Local imports - components
import RepairEditActions from './RepairEditActions';
import RepairForm from './RepairForm';
import { useTitle } from '@src/hooks/useTitle';

const RepairEdit = () => {
  const { title } = useTitle('Review Repair');
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Edit
      mutationMode="pessimistic"
      actions={<RepairEditActions />}
      title={title}
      mutationOptions={{
        onSuccess: (data) => {
          notify('Repair review submitted successfully', { type: 'success' });
          // Refresh the page to reload the record with updated status
          // and conditionally render the appropriate sections
          refresh();
        },
        onError: (error: unknown) => {
          if (error instanceof Error) {
            notify(`Error: ${error.message ?? 'Failed to submit repair review'}`, { type: 'error' });
            console.error('Error in RepairForm save handler', error);
          } else {
            notify(`Error: Failed to submit repair review'}`, { type: 'error' });
            console.error('Error in RepairForm save handler', String(error));
          }
        },
      }}
    >
      <RepairForm />
    </Edit>
  );
};

export default RepairEdit;
